import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import accountReducer from './masters/accountSlice';
import loanTypeReducer from './masters/loanTypeSlice';
import memberReducer from './masters/memberSlice';
import optionReducer from './masters/optionSlice';
import NoticeMasterReducer  from './masters/noticeSlice';
import TermDepositReducer from './masters/termDepositSlice'
import DepositAccountsReducer from './loandeposits/depositAccountSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  account: accountReducer,
  loanTypes: loanTypeReducer,
  member: memberReducer,
  noticesMaster: NoticeMasterReducer,
  option: optionReducer,
  termDeposits: TermDepositReducer,
  termDepositAccounts: DepositAccountsReducer,
});

const persistConfig = { 
  key: 'root',
  storage,
  whitelist: ['auth'] // persist only auth slice
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
export default store;
